const storageKey = (userId, type, key) => `artis-module:${userId}:${type}:${key}`;
/** {@link ModuleStorage} over a web `Storage` backend (the `session` and `browser` scopes), namespaced by user id and module type. `subscribe` is a no-op in v1. */
export const localScopeStore = (backend, type, config) => ({
    get: async (key) => {
        const { userId } = await config();
        const raw = backend.getItem(storageKey(userId, type, key));
        if (raw === null)
            return undefined;
        try {
            return JSON.parse(raw);
        }
        catch {
            return undefined;
        }
    },
    set: async (key, value) => {
        const { userId } = await config();
        backend.setItem(storageKey(userId, type, key), JSON.stringify(value));
    },
    remove: async (key) => {
        const { userId } = await config();
        backend.removeItem(storageKey(userId, type, key));
    },
    subscribe: () => () => { },
});
//# sourceMappingURL=localScopeStore.js.map